import Vue from "vue";
import VueRouter from "vue-router";
import i18n from '@/helpers/i18n';

//Views
import HomePage from "../views/HomePage.vue";
import TeamPage from "../views/TeamPage.vue";
import TeamDetail from "../views/TeamDetail.vue";
import FleetPage from "../views/FleetPage.vue";
import FleetDetail from "../views/FleetDetail.vue";
import OurServicesPage from "../views/OurServicesPage.vue";
import Contact from "../views/Contact.vue";
import StaticInfos from "../views/StaticInfos.vue";
import TeamDetailOld from "../views/TeamDetailOld.vue";
import Gallery from "../views/Gallery.vue";

//Header and footer
import AppHeader from "../layout/AppHeader.vue";
import AppFooter from "../layout/AppFooter.vue";

// Page 404
import Page404 from "../views/Page404.vue";

Vue.use(VueRouter);

import { CONSTANTS } from '@/helpers/consts';

const routes = [
  {
    path: "/",
    name: "HomePage",
    components: {
      header: AppHeader,
      default: HomePage,
      footer: AppFooter,
    }
  },
  {
    path: i18n.t('vueRoutes.team'),
    alias: CONSTANTS.supportedLanguages.map(locale => i18n.t('vueRoutes.team', locale.key) ),
    name: 'team',
    components: {
      header: AppHeader,
      default: TeamPage,
      footer: AppFooter
    }
  },
  {
    path: `${i18n.t('vueRoutes.team')}/:teamSlug`,
    alias: CONSTANTS.supportedLanguages.map(locale => `${i18n.t('vueRoutes.team', locale.key)}/:teamSlug` ),
    name: 'TeamDetail',
    components: {
      header: AppHeader,
      default: TeamDetail,
      footer: AppFooter
    }
  },
  {
    path: i18n.t('vueRoutes.fleet'),
    alias: CONSTANTS.supportedLanguages.map(locale => i18n.t('vueRoutes.fleet', locale.key) ),
    name: 'fleet',
    components: {
      header: AppHeader,
      default: FleetPage,
      footer: AppFooter
    }
  },
  {
    path: `${i18n.t('vueRoutes.fleet')}/:fleetSlug`,
    alias: CONSTANTS.supportedLanguages.map(locale => `${i18n.t('vueRoutes.fleet', locale.key)}/:fleetSlug` ),
    name: 'FleetDetail',
    components: {
      header: AppHeader,
      default: FleetDetail,
      footer: AppFooter
    }
  },
  {
    path: i18n.t('vueRoutes.services'),
    alias: CONSTANTS.supportedLanguages.map(locale => i18n.t('vueRoutes.services', locale.key) ),
    name: 'ourServicesPage',
    components: {
      header: AppHeader,
      default: OurServicesPage,
      footer: AppFooter
    }
  },
  {
    path: i18n.t('vueRoutes.contact'),
    alias: CONSTANTS.supportedLanguages.map(locale => i18n.t('vueRoutes.contact', locale.key) ),
    name: 'Contact',
    components: {
      header: AppHeader,
      default: Contact,
      footer: AppFooter
    }
  },
  {
    path: i18n.t('vueRoutes.gallery'),
    alias: CONSTANTS.supportedLanguages.map(locale => i18n.t('vueRoutes.gallery', locale.key) ),
    name: 'Gallery',
    components: {
      header: AppHeader,
      default: Gallery,
      footer: AppFooter
    }
  },
  {
    path: `${i18n.t('vueRoutes.teamDetail')}/:memberSlug`,
    alias: CONSTANTS.supportedLanguages.map(locale => `${i18n.t('vueRoutes.teamDetail', locale.key)}/:memberSlug` ),
    name: 'TeamDetailOld',
    components: {
      header: AppHeader,
      default: TeamDetailOld,
      footer: AppFooter
    },
  },
  {
    path: "/:slug",
    name: 'StaticInfos',
    components: {
      header: AppHeader,
      default: StaticInfos,
      footer: AppFooter
    },
  },
  {
    path: '*',
    name: '404',
    components: {
      header: AppHeader,
      default: Page404,
      footer: AppFooter
    }
  }, 
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
